module.exports = __webpack_public_path__ + "img/home_tabletennis.0a66a9b0.jpg";